const formStatusLabelFormActions = {
  label: 'Status'
};

export default formStatusLabelFormActions;
